import { api } from "./session-api";
import { initializeVkGamesSdk } from "./vkgames-sdk";

export async function prepareVkGamesLaunch(
  config: typeof api.vkGamesConfig = api.vkGamesConfig,
  initialize: () => Promise<void> = initializeVkGamesSdk,
): Promise<string> {
  await initialize();
  const settings = await config();
  if (!settings.enabled) throw new Error("Вход через ВКонтакте пока не подключён.");
  return settings.appId;
}
